import type { Op } from 'quill/core';

const getPostIdsFromOps = (ops: Op[]) => {
  return ops
    .filter(
      (op): op is Op & { insert: { mention: { type: 'post'; id: string } } } =>
        typeof op.insert === 'object' &&
        typeof op.insert?.mention === 'object' &&
        op.insert.mention != null &&
        'type' in op.insert.mention &&
        op.insert.mention?.type === 'post',
    )
    .map((op) => op.insert.mention.id);
};

export default getPostIdsFromOps;
